import { Component, Input } from '@angular/core';
import { Package } from '../../../models/package.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PackageModalComponent } from '../../../components/package-modal/package-modal.component';
import { PackageService } from '../../../services/package.service';
import { NeighborhoodService } from '../../../services/neighborhood.service';

@Component({
  selector: 'app-packages-list',
  templateUrl: './packages-list.component.html',
  styleUrl: './packages-list.component.scss'
})
export class PackagesListComponent {

  @Input() packages: Package[] = [];
  @Input() neighborhoodId?: string;
  @Input() pickupDate: boolean = false;

  constructor(
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
    public packageService: PackageService,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR open                                */
  /* -------------------------------------------------------------------------- */
  // region open
  open(
    packageItem: Package
  ) {
    const modalRef = this.modalService.open(
      PackageModalComponent
    );

    modalRef.componentInstance.package = packageItem;
  }

}
